module.exports = __webpack_public_path__ + "static/media/hint.0066880e.jpg";